module.exports = __webpack_public_path__ + "media/images/common/order_btn2_s-72f5f0719def13791520029f4223497c.png";